import { DurationLike } from 'luxon';
import { StateCreator } from 'zustand';

export const CHECKLIST_MAX_TIME_AGO: DurationLike = { days: 7 };

export interface OnboardingRequiredChecklistState {
    hasSeenChecklistCompleteDialog: boolean;
    completedRequiredChecklistThisSession: boolean;
    completedRequiredChecklistBetweenSessions: boolean;
    hasSeenCompletedConfetti: boolean;
    wasCompletedOverMaxTimeAgo: boolean;
    permanentlyDismissFloatingChecklist: boolean;
    setHasSeenChecklistCompleteDialog: (hasSeen: boolean) => void;
    setCompletedRequiredChecklistThisSession: (completedThisSession: boolean) => void;
    setCompletedRequiredChecklistBetweenSessions: (completedBetweenSessions: boolean) => void;
    setHasSeenCompletedConfetti: (hasSeen: boolean) => void;
    setWasCompletedOverMaxTimeAgo: (wasCompleted: boolean) => void;
    setPermanentlyDismissFloatingChecklist: (dismiss: boolean) => void;
}

export const createOnboardingRequiredChecklistSlice: StateCreator<
    any,
    [['zustand/persist', unknown]],
    [],
    OnboardingRequiredChecklistState
> = set => ({
    hasSeenChecklistCompleteDialog: false,
    completedRequiredChecklistThisSession: false,
    completedRequiredChecklistBetweenSessions: false,
    hasSeenCompletedConfetti: false,
    wasCompletedOverMaxTimeAgo: false,
    permanentlyDismissFloatingChecklist: false,
    setHasSeenChecklistCompleteDialog: (hasSeen: boolean) =>
        set({
            hasSeenChecklistCompleteDialog: hasSeen,
        }),
    setCompletedRequiredChecklistThisSession: (completedThisSession: boolean) =>
        set({
            completedRequiredChecklistThisSession: completedThisSession,
        }),
    setCompletedRequiredChecklistBetweenSessions: (completedBetweenSessions: boolean) =>
        set({
            completedRequiredChecklistBetweenSessions: completedBetweenSessions,
        }),
    setHasSeenCompletedConfetti: (hasSeen: boolean) =>
        set({
            hasSeenCompletedConfetti: hasSeen,
        }),
    setWasCompletedOverMaxTimeAgo: (wasCompleted: boolean) =>
        set({
            wasCompletedOverMaxTimeAgo: wasCompleted,
        }),
    setPermanentlyDismissFloatingChecklist: (dismiss: boolean) =>
        set({
            permanentlyDismissFloatingChecklist: dismiss,
        }),
});
